import { Box, Typography } from "@mui/material";
import MenuEntry from "./MenuEntry";

const MenuList = ({ listEntry, browserUri, onMobileClose }) => {
  return (
    <Box className="menu-list-container">
      <Typography variant="subtitle2" className="list-title">
        {listEntry.title}
      </Typography>

      <Box className="list-entries">
        {listEntry.entries.map((entry, entryIndex) => (
          <MenuEntry
            key={`${entry.uri}-${entryIndex}`}
            entry={entry}
            browserUri={browserUri}
            onMobileClose={onMobileClose}
          />
        ))}
      </Box>
    </Box>
  );
};

export default MenuList;